export default "__VITE_ASSET__DzSErOzp__"